<!-- 工单详情 -->
<template>
  <a-modal
    v-if="visible"
    v-model:visible="visible"
    :footer="null"
    @cancel="handleCancel"
    :centered="true"
    :destroyOnClose="true"
    :closable="false"
    width="80%"
    :bodyStyle="{
      height: subWorkOrders && subWorkOrders.length ? '93vh' : '88vh',
      padding: '0px 18px 18px'
    }"
    class="patient-wrap"
    wrapClassName="workOrderDetailTabsModal"
  >
    <template #title>
      <!-- 医生所在医院名称 -->
      <div
        v-if="relatedOrderMaps.get(activeWorkOrderId).hospitalFollowName && !isBDOrder"
        class="hospital z-flex-l"
      >
        <div v-if="relatedOrderMaps.get(activeWorkOrderId).hospitalFollowUrl">
          <a-avatar
            class="hospital-avatar"
            :size="24"
            :src="relatedOrderMaps.get(activeWorkOrderId).hospitalFollowUrl"
            shape="square"
            alt="医院图片"
          />
        </div>
        <div class="hospital-name">
          {{ relatedOrderMaps.get(activeWorkOrderId).hospitalFollowName }}
        </div>
      </div>
    </template>
    <div class="bodyContent" style="margin-bottom: 10px">
      <a-tabs
        class="workOrder-tabs"
        v-model:activeKey="activeWorkOrderId"
        @change="changeWorkOrderId"
      >
        <a-tab-pane
          v-for="[workOrderId] in Array.from(relatedOrderMaps)"
          :key="workOrderId"
          :value="workOrderId"
          :tab="
            workOrderId === currentInfo.workOrderId
              ? `当前工单：${workOrderId}`
              : `关联工单：${workOrderId}`
          "
        >
          <a-radio-group
            v-if="subWorkOrders && subWorkOrders.length"
            v-model:value="subWorkOrderIdCurrent"
            @change="subOrderSelect"
          >
            <a-radio-button
              v-for="sonOrder in subWorkOrders"
              :key="sonOrder.id"
              :value="sonOrder.id"
            >
              {{ sonOrder.followBusinessName }} {{ sonOrder.id }}
            </a-radio-button>
          </a-radio-group>
          {{ relatedOrderMaps.get(activeWorkOrderId)?.adSubTaskRecordId }}
          <a-spin :spinning="orderFetching">
            <a-tabs
              :animated="false"
              v-model:activeKey="activeKey"
              class="patient-tabs"
              type="card"
              :style="{ marginTop: subWorkOrders && subWorkOrders.length ? '24px' : 0 }"
            >
              <a-tab-pane :key="tab.key" :tab="tab.label" v-for="tab in newSupportTabs">
                <component
                  v-if="activeWorkOrderId == workOrderId && activeKey === tab.key"
                  mode="read"
                  :is="tab.component"
                  class="detailComponent"
                  :ref="el => setTabRef(el, tab.ref)"
                  :ucUserId="relatedOrderMaps.get(activeWorkOrderId).ucPatientId"
                  :patientId="relatedOrderMaps.get(activeWorkOrderId).patientId"
                  :ucDoctorId="relatedOrderMaps.get(activeWorkOrderId).ucDoctorId"
                  :doctorId="relatedOrderMaps.get(activeWorkOrderId).doctorId"
                  :patientName="relatedOrderMaps.get(activeWorkOrderId).ucPatientName"
                  :workOrderId="relatedOrderMaps.get(activeWorkOrderId).workOrderId"
                  :adSubTaskRecordId="relatedOrderMaps.get(activeWorkOrderId)?.showSubWorkId"
                  :businessType="relatedOrderMaps.get(activeWorkOrderId)?.businessType"
                  :followBusinessType="relatedOrderMaps.get(activeWorkOrderId)?.followBusinessType"
                  :id="relatedOrderMaps.get(activeWorkOrderId)?.id"
                  :groupId="relatedOrderMaps.get(activeWorkOrderId)?.doctorPatientGroupId"
                  :privateId="relatedOrderMaps.get(activeWorkOrderId)?.assistantPatientGroupId"
                  :guideConsultGroupId="
                    relatedOrderMaps.get(activeWorkOrderId)?.guideConsultGroupId
                  "
                  :doctorDaGroupId="relatedOrderMaps.get(activeWorkOrderId)?.assistantDoctorGroupId"
                  @closeSummaryModal="handleCancel"
                  @emitTrace="findTaceRow"
                  @orderFinish="orderFetching = false"
                  :isBDOrder="isBDOrder"
                  :isComponent="true"
                  origin="orderDetails"
                />
              </a-tab-pane>
            </a-tabs>
          </a-spin>
        </a-tab-pane>
      </a-tabs>
      <div class="icon">
        <CloseOutlined @click.stop="handleCancel" />
      </div>
    </div>
  </a-modal>
</template>
<script setup>
import { defineProps, computed, defineEmits, ref, watch } from 'vue'
import { useStore } from 'vuex'
import {
  tabs,
  defaultOrderTabs,
  specialOrderTabs,
  subOrderTypes,
  subOrderTabConfigs,
  BDOrderTabs,
  followUpTabs
} from './config'
import { getSubTaskList } from '@/api/Todo/index.js'
import { apiQueryRelationWorkOrder } from '@/api/workPlace/workOrder'
import { message } from 'ant-design-vue'
import { getBDSubTaskDetail } from '@/api/Todo/bdWorkorder'
import { CloseOutlined } from '@ant-design/icons-vue'
import { SHOW_FOLLOWUP_TAB } from './eventBuss'
const props = defineProps({
  currentInfo: {
    type: Object,
    default: () => {},
    required: true
  },
  showAllDialog: {
    type: Boolean,
    default: false,
    require: true
  },
  // 只展示患者信息
  onlyPatientInfo: {
    type: Boolean,
    default: false
  },
  // 只展示某个tab
  activeTab: {
    type: Number,
    default: 0
  },
  isBDOrder: {
    type: Boolean, //是否BD工单
    default: false
  }
})

const store = useStore()
const reflist = ref({})
const setTabRef = (el, key) => {
  if (el) {
    reflist.value[key] = el
  }
}

// 当前显示的工单
const orderFetching = ref(false)
const relatedOrderMaps = ref(new Map())
const activeWorkOrderId = ref(null)
const ORDER_ACTIVE = computed(() => relatedOrderMaps.value.get(activeWorkOrderId.value))
const newSupportTabs = computed(() => {
  if (insideHospitalFlag.value) {
    if (supportTabs.value.find(it => it.key === 18)) return supportTabs.value
    return [...supportTabs.value, followUpTabs]
  } else {
    return supportTabs.value.filter(item => item.key !== 18)
  }
})
// 切换工单
const changeWorkOrderId = async e => {
  orderFetching.value = true
  subWorkOrderIdCurrent.value = null
  activeWorkOrderId.value = e
  props.isBDOrder ? await getBDSubOrderListFn() : await getSubOrderListFn()
}

// 选择子工单逻辑
const subWorkOrders = ref([])
const subWorkOrderIdCurrent = ref(null)
const subOrderSelect = e => {
  orderFetching.value = true
  activeKey.value = 17
  const subOrderItem = subWorkOrders.value.find(item => item.id === e.target.value)
  relatedOrderMaps.value.set(activeWorkOrderId.value, subOrderItem)
}

// 查询是否有子工单(健管)
const getSubOrderListFn = async () => {
  subWorkOrders.value = []
  subWorkOrderIdCurrent.value = null
  const { workOrderId, businessType } = ORDER_ACTIVE.value
  if (subOrderTypes.includes(businessType)) {
    orderFetching.value = true
    const result = await getSubTaskList({
      workOrderId,
      subTaskBusinessType: 'DA_CURE_RESERVE_ORDER'
    })
    subWorkOrders.value = result.length ? result : []
    if (!result.length) {
      return message.warning('暂无子工单!')
    }
    subWorkOrderIdCurrent.value = result[0].id
    relatedOrderMaps.value.set(activeWorkOrderId.value, result[0])
    orderFetching.value = true
  }
}
// 查询是否有子工单（BD）
const getBDSubOrderListFn = async () => {
  subWorkOrders.value = []
  subWorkOrderIdCurrent.value = null
  const { workOrderId, businessType } = ORDER_ACTIVE.value
  if (subOrderTypes.includes(businessType)) {
    orderFetching.value = true
    const result = await getBDSubTaskDetail({
      workOrderId
    })
    subWorkOrders.value = result ?? []
    if (!result.length) {
      return message.warning('暂无子工单!')
    }
    subWorkOrderIdCurrent.value = result[0].id
    relatedOrderMaps.value.set(activeWorkOrderId.value, result[0])
    orderFetching.value = true
  }
}
const supportTabs = ref([])
const emits = defineEmits(['handleCancel'])
const visible = computed(() => props.showAllDialog)
const activeKey = ref(1)

watch(
  () => ORDER_ACTIVE.value,
  val => {
    val && initTabsByWorkOrderType()
  },
  {
    deep: true,
    immediate: true
  }
)
watch(
  () => props.currentInfo.workOrderId,
  val => {
    visible.value && runRelatedTabs()
  }
)
const initModal = () => {
  supportTabs.value = []
  insideHospitalFlag.value = []
  SHOW_FOLLOWUP_TAB?.on(flag => updateTabs(flag))
}
const insideHospitalFlag = ref(false)
function updateTabs(flag) {
  insideHospitalFlag.value = flag
}
// 查询关联工单
const runRelatedTabs = async () => {
  reflist.value = {}
  orderFetching.value = true
  initModal()
  const { workOrderId } = props.currentInfo
  relatedOrderMaps.value.set(workOrderId, props.currentInfo)
  activeWorkOrderId.value = workOrderId
  const orderList = (await apiQueryRelationWorkOrder({ workOrderId })) || []
  orderList.forEach(item => {
    relatedOrderMaps.value.set(item.workOrderId, item)
  })
  await getSubOrderListFn()
}

const findTaceRow = param => {
  if (!supportTabs.value.map(item => item.ref).includes('handlingTrace')) return
  activeKey.value = 14
  setTimeout(() => {
    reflist.value.handlingTrace.activeCtxRow(param)
  })
}

// 当前工单类型的配置
function initTabsByWorkOrderType() {
  const { businessType, followBusinessType } = ORDER_ACTIVE.value
  if (!businessType) return
  if (props.isBDOrder) {
    activeKey.value = 17
    supportTabs.value = tabs.filter(it => BDOrderTabs.includes(it.ref))
    return
  }
  // 只展示某一个
  if (props.activeTab) {
    activeKey.value = props.activeTab
    supportTabs.value = tabs.filter(it => it.key === props.activeTab || it.key === 11)
    return
  }
  // onlyPatientInfo业务逻辑
  if (props.showAllDialog && props.onlyPatientInfo) {
    const notInclude = ['workorderDetails', 'chat'] // 不包含下面内容
    activeKey.value = 3
    supportTabs.value = tabs.filter(it => !notInclude.includes(it.ref))
    return
  }
  // 有子工单的
  if (followBusinessType && subOrderTypes.includes(businessType)) {
    const { tabsConfig = {} } = subOrderTabConfigs[followBusinessType]
    activeKey.value = tabsConfig?.activeKey
    supportTabs.value = tabs.filter(it => tabsConfig?.supportTabs.includes(it.ref))
    return
  }
  // 默认的 配置的
  const isSpecialType = Object.keys(specialOrderTabs).includes(businessType.toString())
  const source = isSpecialType ? specialOrderTabs[businessType] : defaultOrderTabs
  supportTabs.value = tabs.filter(it => source.includes(it.ref))
  activeKey.value = 1
}

const handleCancel = () => {
  relatedOrderMaps.value.clear()
  subWorkOrders.value = []
  activeWorkOrderId.value = undefined
  SHOW_FOLLOWUP_TAB?.off()
  emits('handleCancel')
}
</script>
<style scoped lang="scss">
.patient-wrap {
  .hospital {
    padding: 10px 24px;
    background: #f3f6fa;
    align-items: flex-start;
    .hospital-avatar {
      margin-right: 6px;
    }
    .hospital-name {
      font-weight: bold;
      font-size: 14px;
      color: #495d87;
      line-height: 24px;
    }
  }

  .bodyContent {
    position: relative;

    .workOrder-tabs {
      ::v-deep(> .ant-tabs-bar) {
        margin-right: 40px;
      }
    }

    .icon {
      position: absolute;
      top: 10px;
      right: 0px;
      font-size: 18px;
      color: #00000040;
    }
  }

  .patient-tabs {
    ::v-deep(.ant-tabs-top-content, .ant-tabs-bottom-content) {
      max-height: calc(86vh - 127px);
    }
    .detailComponent {
      height: calc(86vh - 127px);
      overflow: scroll;
    }
  }
}
</style>
